module.exports = __webpack_public_path__ + "media/icons/smartsearch/colors/gray-c7fd05aba82476ceb1135754729f41b4.png";